// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 3 hooks for backend/today.

import { useBackend } from '../useBackend'

/** POST /api/today/getTodayPlatform */
export function useGetTodayPlatform<T = any>() {
  return useBackend<T>('today/getTodayPlatform')
}

/** POST /api/today/getTodayView */
export function useGetTodayView<T = any>() {
  return useBackend<T>('today/getTodayView')
}

/** POST /api/today/setTodayView */
export function useSetTodayView<T = any>() {
  return useBackend<T>('today/setTodayView')
}
